import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export interface FeatureToggleReducer {
    kredittkortSoknadSbl: boolean;
    kredittkortTrafficLight: boolean;
    kredittkortBlockEikaNewCard: boolean;
}
export const initialState: FeatureToggleReducer = {
    kredittkortSoknadSbl: false,
    kredittkortTrafficLight: false,
    kredittkortBlockEikaNewCard: false,
};

export const featureReducer = (state = initialState, action: AppActions = {} as AppActions) => {
    switch (action.type) {
        case actionTypes.FEATURE_TOGGLE_FULFILLED:
            return { ...state, ...action.payload, kredittkortSoknadSbl: false };
        default:
            return state;
    }
};
